@use "styles/mixins/_rem.scss" as rem;

.button {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: var(--size-border-radius-pill);
  background-color: transparent;
  color: var(--color-icon-subtle);
  width: rem.torem(24px);
  height: rem.torem(24px);

  &:focus-visible {
    outline: rem.torem(1px) solid var(--color-outline-default);
    outline-offset: rem.torem(2px);
  }

  &:disabled {
    cursor: default;
  }
}
